/*
 * Contrats de prévente (préfinancement) : libellés côté acheteur. Les valeurs viennent de
 * agri-product-platform (ContractView, PaymentView, EscrowOrderView) ; mêmes libellés que
 * l'espace entreprise du producteur.
 */

export const CONTRACT_STATUS = {
    AWAITING_SIGNATURES: { label: "À signer", color: "blue" },
    AWAITING_ADVANCE: { label: "Avance attendue", color: "gold" },
    IN_PRODUCTION: { label: "En production", color: "green" },
    DELIVERY_DECLARED: { label: "Livraison déclarée", color: "cyan" },
    AWAITING_BALANCE: { label: "Solde attendu", color: "gold" },
    COMPLETED: { label: "Terminé", color: "default" },
    CANCELLED: { label: "Annulé", color: "red" },
};

export const PAYMENT_KIND = { ADVANCE: "Avance", BALANCE: "Solde" };

export const CONTRACT_PAYMENT_STATUS = {
    PENDING: { label: "En attente", color: "processing" },
    PROCESSING: { label: "En cours", color: "processing" },
    SUCCEEDED: { label: "Réussi", color: "success" },
    FAILED: { label: "Échoué", color: "error" },
    CANCELLED: { label: "Annulé", color: "default" },
    EXPIRED: { label: "Expiré", color: "default" },
};

export const ACTIVE_CONTRACT_PAYMENT = ["PENDING", "PROCESSING"];

export const ESCROW_KIND = {
    PAYOUT_PRODUCER: "Versement au producteur",
    REFUND_BUYER: "Remboursement à vous",
    COLLECT_PRODUCER: "Dû par le producteur",
};

export const ESCROW_PURPOSE = {
    ADVANCE: "Avance",
    BALANCE: "Solde",
    SHORTFALL: "Quantité manquante",
    COMMISSION: "Commission",
};

export const ESCROW_STATUS = {
    PENDING: { label: "En cours", color: "gold" },
    EXECUTED: { label: "Exécuté", color: "green" },
    CANCELLED: { label: "Annulé", color: "default" },
};

/** Le préfinancement se paie en ligne uniquement. */
export const CONTRACT_PAYMENT_METHODS = ["MOBILE_MONEY", "CARD"];

export const CANCELLABLE_STATUSES = ["AWAITING_SIGNATURES", "AWAITING_ADVANCE"];

/** Ce que le contrat attend de l'acheteur, ou null. */
export const buyerTodo = (contract) => {
    switch (contract?.status) {
        case "AWAITING_SIGNATURES":
            return contract.buyerSignature ? null : "Signer";
        case "AWAITING_ADVANCE":
            return "Payer l'avance";
        case "DELIVERY_DECLARED":
            return "Confirmer la livraison";
        case "AWAITING_BALANCE":
            return "Payer le solde";
        default:
            return null;
    }
};

/** Taux 0.03 → « 3 % ». */
export const formatRate = (rate) =>
    `${new Intl.NumberFormat("fr-FR", { maximumFractionDigits: 2 }).format(Number(rate) * 100)} %`;
